import script from "./DetailedInquiry.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetailedInquiry.vue?vue&type=script&lang=ts&setup=true"

import "./DetailedInquiry.vue?vue&type=style&index=0&id=6dc3e5c3&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dc3e5c3"]])

export default __exports__